import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "b74f6bf6-3d71-4553-9418-783ebc71ef2e",
    content: "CTC reproduces binaural signals at the ears of the listener.",
    options: {},
  },
  { id: "1f2e4883-2af3-4769-8147-65cb77327ef8", content: "CTC is usually applied for multiple users.", options: {} },
  {
    id: "ec93feaf-8835-4792-a13e-f5cedef8168f",
    content: "Small changes in the rotation or position of the user make the filter invalid.",
    options: {},
  },
  {
    id: "3209c154-9237-40a3-8db3-a930f0d40fa1",
    content: "Rotation of the user doesn’t matter for the cancellation filter.",
    options: {},
  },
];

export const task: Task = {
  id: "ad4d6549-5c65-44e9-8513-960c9754727f",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: true,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["b74f6bf6-3d71-4553-9418-783ebc71ef2e", "ec93feaf-8835-4792-a13e-f5cedef8168f"],
};
